/** 规格转换为像素单位 */
export const transSpecToPx = (mm: number) => Math.round((mm / 210) * 800)

/** 规格转换为毫米单位 */
export const transSpecToMm = (px: number) => Math.round((px / 800) * 210)
